function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-824 -483.404)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M138.944-.218c68.1-14.33,138.791,89.785,96.892,140.441S178.162,258.5,128.209,253.805,0,198.781,0,127.979C-.6,25.575,96.923,21.385,138.944-.218Z",
  transform: "translate(824.003 484.963)",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.788 -41)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(859 579)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 106,
  height: 139,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 98,
  height: 131,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(874 595)",
  fill: "#b5c7df",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 76,
  height: 25,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 68,
  height: 17,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile1",
  transform: "translate(874 624)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile2",
  transform: "translate(874 651)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile3",
  transform: "translate(874 679)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile4",
  transform: "translate(901 624)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile5",
  transform: "translate(901 651)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile6",
  transform: "translate(901 679)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  className: "tile7",
  transform: "translate(928 624)",
  fill: "#fff",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  rx: 6,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 15,
  height: 15,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(928 651)",
  fill: "#3a76c4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 17 47 L 6 47 C 4.897200107574463 47 4 46.10279846191406 4 45 L 4 6 C 4 4.897200107574463 4.897200107574463 4 6 4 L 17 4 C 18.1028003692627 4 19 4.897200107574463 19 6 L 19 45 C 19 46.10279846191406 18.1028003692627 47 17 47 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 8 8 L 8 43 L 15 43 L 15 8 L 8 8 M 6 0 L 17 0 C 20.31370735168457 0 23 2.686290740966797 23 6 L 23 45 C 23 48.3137092590332 20.31370735168457 51 17 51 L 6 51 C 2.68629264831543 51 0 48.3137092590332 0 45 L 0 6 C 0 2.686290740966797 2.68629264831543 0 6 0 Z",
  stroke: "none",
  fill: "#3a76c4"
}))));

var SvgCommitting = function SvgCommitting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248.407,
    height: 255.596,
    viewBox: "0 0 248.407 255.596",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommitting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Committing.74532556.svg";
export { ForwardRef as ReactComponent };